import React from "react";
import { Box, Container, Grid, Typography, Card, Stack } from "@mui/material";

import PrecisionManufacturingRoundedIcon from "@mui/icons-material/PrecisionManufacturingRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import HandshakeRoundedIcon from "@mui/icons-material/HandshakeRounded";

const FEATURES = [
  {
    title: "Industry Expertise",
    description:
      "Strong domain experience across manufacturing, oil & gas, retail, utilities, logistics, healthcare, and life sciences.",
    icon: PrecisionManufacturingRoundedIcon,
  },
  {
    title: "SAP Excellence",
    description:
      "60+ Certified SAP consultants with expertise in S/4HANA, SAP Cloud, SAP Analytics, SAP Integration, and enterprise transformation.",
    icon: WorkspacePremiumRoundedIcon,
  },
  {
    title: "Innovation-Driven",
    description:
      "Leveraging AI, IoT, automation, analytics, cloud computing, and intelligent business processes.",
    icon: AutoAwesomeRoundedIcon,
  },
  {
    title: "Customer-Centric",
    description:
      "We work closely with clients to understand business goals and deliver tailored solutions.",
    icon: HandshakeRoundedIcon,
  },
];

const styles = {
  section: {
    py: { xs: 4, md: 6 },
    background: "#071525",
  },

  header: {
    mb: 3,
    textAlign: "center",
  },

  label: {
    color: "#00c853",
    fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
    fontWeight: 600,
    letterSpacing: 1.5,
    mb: 1,
  },

  title: {
    color: "#fff",
    fontWeight: 800,
    fontSize: { xs: "1.7rem", md: "2rem" },
  },

  card: {
    height: "100%",
    p: 2.5,
    borderRadius: "22px",
    color: "#fff",
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.08)",
    backdropFilter: "blur(12px)",
    transition: "0.35s ease",

    "&:hover": {
      transform: "translateY(-6px)",
      borderColor: "rgba(0,200,83,0.35)",
      boxShadow: "0 14px 30px rgba(0,0,0,0.25)",
    },
  },

  iconBox: {
    width: 42,
    height: 42,
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#00e676",
    background:
      "linear-gradient(135deg, rgba(0,200,83,0.18), rgba(0,230,118,0.08))",
    border: "1px solid rgba(0,230,118,0.2)",

    "& svg": {
      fontSize: 22,
    },
  },

  cardTitle: {
    fontWeight: 700,
    fontSize: { xs: "1rem", md: "1.25rem" },
    color: "#fff",
    alignItems: "center",
    pt: 1,
  },

  description: {
    color: "rgba(255,255,255,0.68)",
    fontSize: { xs: "0.8rem", md: "1rem" },
    lineHeight: 1.5,
  },
};

function SectionHeader() {
  return (
    <Box sx={styles.header}>
      <Typography sx={styles.label}>WHY CHOOSE US</Typography>
    </Box>
  );
}

function FeatureCard({ title, description, icon: Icon }) {
  return (
    <Card sx={styles.card}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box sx={styles.iconBox}>
            <Icon />
          </Box>

          <Typography sx={styles.cardTitle}>{title}</Typography>
        </Stack>

        <Typography sx={styles.description}>{description}</Typography>
      </Stack>
    </Card>
  );
}

export default function WhyChooseUs() {
  return (
    <Box component="section" sx={styles.section}>
      <Container maxWidth="lg">
        <SectionHeader />

        <Grid container spacing={2.5}>
          {FEATURES.map((feature, index) => (
            <Grid item size={{ xs: 12, sm: 6 }} key={index}>
              <FeatureCard {...feature} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
